import React, { useState, useEffect, useRef } from "react";
import "./Operations.css";
import TopRightActionLinks from "../../TopRightActionLinks";
import InsightBlock from "../../InsightBlock";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import { submitCompetitorProfileV4Request } from "../../../../../store/features/actions/competitorProfileV4Actions";
import VendorMapOperations from "./VendorMapOperations";
import WorldHeatmap from "../../../../HtmlElements/WorldHeatmap";
import LineChartWithShadow from "../../../../HtmlElements/LineChartWithShadow";
import RawMaterialSourcing from "./RawMaterialSourcing";
import CostStructureAnalysis from "./CostStructureAnalysis";
import DistributionStrategy from "./DistributionStrategy";
import PerformanceMetrics from "./PerformanceMetrics";
import ManufacturingAndTechnologyInfrastructure from "./ManufacturingAndTechnologyInfrastructure";
import {
  formatBoldText,
  formatBoldTextOlder,
  getAllSubdimensionMatches,
  getAllDynamicSubdimensionMatches,
  getCompProfilePageInsights,
  hasData,
} from "../../../../../services/commonService";
import useDynamicSubtabs from "../../../../../hooks/useDynamicSubtabs";
import SupplyChainOverview from "./SupplyChainOverview";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import RawMaterialImports from "./RawMaterialImports";
import CapexTrends from "./CapexTrends";
import Tier1Supplier from "./Tier1Supplier";
import InboundLogistics from "./InboundLogistics";
import PortsOfEntry from "./PortsOfEntry";
import WarehousingChannels from "./WarehousingChannels";
import ChannelPartner from "./ChannelPartner";
import OutboundDistributions from "./OutboundDistributions";
import ExportChannels from "./ExportChannels";
import TradeExposure from "./TradeExposure";
import Sustainability from "./Sustainability";
import Finance from "./Finance";
import Innovation from "./Innovation";
import Risks from "./Risks";
import QuantSection from "./QuantSection";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import APP_CONFIG from "../../../../../config/appConfig";
import useActiveScrollSection from "../../../../../hooks/useActiveScrollSection";
import * as FeatherIcon from "react-feather";
import useDynamicTableExport from "../../../../../hooks/useDynamicTableExport";

function Operations({
  activeSubKey,
  setActiveSubKey,
  compView,
  dataReportCheck,
  scrollTarget,
  marketIqClient,
  clientCompanyType,
  existingSubdimensions,
  subdimensionStatus,
  registerDynamicTabs,
}) {
  const { user } = useUser();
  const { exportTableToCSV } = useDynamicTableExport();
  const operationsInsightRef = useRef(null);
  const rawMaterialImportsRef = useRef(null);
  const quantSnapshotRef = useRef(null);
  const globalOperationsNetworkRef = useRef(null);
  const capexTrendsRef = useRef(null);
  const tier1SuppliersRef = useRef(null);
  const inboundLogisticsRef = useRef(null);
  const warehousingChannelsRef = useRef(null);
  const outboundDistributionRef = useRef(null);
  const tradeExposureRef = useRef(null);
  const costStructureAnalysisRef = useRef(null);
  const sustainabilityFinanceInnovationRisksRef = useRef(null);
  const programmaticScrollRef = useRef(false);
  const dynamicRefs = useRef({});
  const containerRef = useRef(null);
  const [dynamicReady, setDynamicReady] = useState(0);
  const sectionMap = {
    operationsInsightTab: operationsInsightRef,
    quantSnapshotTab: quantSnapshotRef,
    globalOperationsNetworkTab: globalOperationsNetworkRef,
    // capexTrendsTab: capexTrendsRef,
    tier1SuppliersTab: tier1SuppliersRef,
    rawMaterialImportsTab: rawMaterialImportsRef,
    inboundLogisticsTab: inboundLogisticsRef,
    warehousingChannelsTab: warehousingChannelsRef,
    outboundDistributionTab: outboundDistributionRef,
    tradeExposureTab: tradeExposureRef,
    costStructureAnalysisTab: costStructureAnalysisRef,
    sustainabilityFinanceInnovationRisksTab:
      sustainabilityFinanceInnovationRisksRef,
    ...Object.fromEntries(
      Object.entries(dynamicRefs.current).map(([key, el]) => [
        key,
        { current: el },
      ])
    ),
  };

  // useActiveScrollSection(
  //   sectionMap,
  //   activeSubKey,
  //   setActiveSubKey,
  //   programmaticScrollRef
  // );

  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    dynamicReady, // NEW
    containerRef // NEW
  );

  const [dynamicSubdimension, setDynamicSubdimension] = useState([]);
  useDynamicSubtabs({
    parentKey: "operations",
    sourceData: dynamicSubdimension,
    registerDynamicTabs,
    keyPrefix: "dynamic_operations",
  });

  // const scrollToSection = (key) => {
  //   const ref = sectionMap[key];
  //   if (!ref?.current) return;

  //   programmaticScrollRef.current = true;

  //   const yOffset = -100;
  //   const y =
  //     ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

  //   window.scrollTo({ top: y, behavior: "smooth" });

  //   setTimeout(() => {
  //     programmaticScrollRef.current = false;
  //   }, 700);
  // };

  const scrollToSection = (key) => {
    const staticRef = sectionMap[key];

    if (staticRef?.current) {
      staticRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      return;
    }

    const dynamicEl = dynamicRefs.current[key];

    if (dynamicEl) {
      dynamicEl.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    }
  };

  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [supplyChainOverview, setSupplyChainOverview] = useState([]);
  const [
    manufacturingAndTechnologyInfrastructure,
    setManufacturingAndTechnologyInfrastructure,
  ] = useState([]);
  const [rawMaterialImports, setRawMaterialImports] = useState([]);
  const [capexTrends, setCapexTrends] = useState([]);
  const [tier1Suppliers, setTier1Suppliers] = useState([]);
  const [inboundLogistics, setInboundLogistics] = useState([]);
  const [warehousingChannels, setWarehousingChannels] = useState([]);
  const [outboundDistributions, setOutboundDistributions] = useState([]);
  const [tradeExposure, setTradeExposure] = useState([]);
  const [susFinInnoRisk, setSusFinInnoRisk] = useState([]);

  const [rawMaterialSourcing, setRawMaterialSourcing] = useState([]);
  const [costStructureAnalysis, setCostStructureAnalysis] = useState([]);
  const [distributionStrategy, setDistributionStrategy] = useState([]);
  const [performanceMetrics, setPerformanceMetrics] = useState([]);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [pageQuantSnapshot, setPageQuantSnapshot] = useState([]);
  const [plantCount, setPlantCount] = useState(0);
  const [operationsDataCheck, setOperationsDataCheck] = useState({
    hasOperationsInsightTabData: true,
    hasQuantSnapshotTabData: true,
    hasGlobalOperationsNetworkTabData: true,
    hasTier1SuppliersTabData: true,
    hasRawMaterialImportsData: true,
    hasInboundLogisticsTabData: true,
    hasWarehousingChannelsTabData: true,
    hasOutboundDistributionTabData: true,
    hasTradeExposureTabData: true,
    hasCostStructureAnalysisTabData: true,
    hasSustainabilityFinanceInnovationRisksTabData: true,
  });

  const existingSubs = existingSubdimensions?.data || [];
  const useExistingSubdimensions = existingSubs.length > 0;

  const normalize = (str) => str?.toLowerCase().replace(/[_\s]/g, "");

  const subdimensionExists = (name) => {
    if (!useExistingSubdimensions) return true;

    return existingSubs.some((s) => normalize(s) === normalize(name));
  };

  const getSubdimensionStatus = (name) => {
    if (!subdimensionStatus) return "complete";

    const { added = [], update_in_progress = [] } = subdimensionStatus;

    const isGenerating =
      added.some((s) => normalize(s) === normalize(name)) ||
      update_in_progress.some((s) => normalize(s) === normalize(name));

    return isGenerating ? "generating" : "complete";
  };

  const GeneratingSkeleton = () => (
    <GenericTableSkeleton colCount={3} rowCount={5} />
  );

  const dispatch = useDispatch();
  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
    // (state) => state.competitorProfileV4Reducer
  );

  const formData = {
    dimension: "OperationsAndSupplyChain",
    client: clientName ?? "H.B. Fuller",
    company: competitorName ?? "Tailored Chemical Products",
    user_id: user?.user_id,
    user_role: user?.growth_iq_role_name,
    user_type:
      user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
  };

  useEffect(() => {
    dispatch(submitCompetitorProfileV3Request(formData));
    // dispatch(submitCompetitorProfileV4Request(formData));
  }, []);

  // Scroll into view when a subsection tab is clicked
  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     operationsInsightTab: operationsInsightRef,
  //     quantSnapshotTab: quantSnapshotRef,
  //     globalOperationsNetworkTab: globalOperationsNetworkRef,
  //     // capexTrendsTab: capexTrendsRef,
  //     tier1SuppliersTab: tier1SuppliersRef,
  //     rawMaterialImportsTab: rawMaterialImportsRef,
  //     inboundLogisticsTab: inboundLogisticsRef,
  //     warehousingChannelsTab: warehousingChannelsRef,
  //     outboundDistributionTab: outboundDistributionRef,
  //     tradeExposureTab: tradeExposureRef,
  //     costStructureAnalysisTab: costStructureAnalysisRef,
  //     sustainabilityFinanceInnovationRisksTab:
  //       sustainabilityFinanceInnovationRisksRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 120; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    const tempDynamicSubdimension = getAllDynamicSubdimensionMatches(data, [
      "Raw Material Sourcing",
      "Raw Material Imports",
      "Tier 1 Suppliers",
      "Inbound Logistics",
      "Warehousing & Channels",
      "Outbound Distribution",
      "Trade Exposure",
      "Cost Structure Analysis",
      "Sustainability, Finance, Innovation, Risks",
      "Distribution Strategy",
      "Performance Metrics",
      "Supply Chain Overview",
      "Global Operations Network",
      "Quantitative Snapshot",
    ]);
    setDynamicSubdimension(tempDynamicSubdimension);

    const tempRawMaterialSourcing = getAllSubdimensionMatches(
      data,
      "Raw Material Sourcing"
      // "Raw Material Imports"
    );
    setRawMaterialSourcing(tempRawMaterialSourcing);

    const tempCapexTrends = getAllSubdimensionMatches(data, "Capex Trends");
    setCapexTrends(tempCapexTrends);

    const tempRawMaterialImports = getAllSubdimensionMatches(
      data,
      "Raw Material Imports"
    );
    setRawMaterialImports(tempRawMaterialImports);

    const tempTier1Supplier = getAllSubdimensionMatches(
      data,
      "Tier 1 Suppliers"
    );
    setTier1Suppliers(tempTier1Supplier);

    const tempInboundLogistics = getAllSubdimensionMatches(
      data,
      "Inbound Logistics"
    );
    setInboundLogistics(tempInboundLogistics);

    const tempWarehousingChannels = getAllSubdimensionMatches(
      data,
      "Warehousing & Channels"
    );
    setWarehousingChannels(tempWarehousingChannels);

    const tempOutboundDistribution = getAllSubdimensionMatches(
      data,
      "Outbound Distribution"
    );
    setOutboundDistributions(tempOutboundDistribution);

    const tempTradeExposure = getAllSubdimensionMatches(data, "Trade Exposure");
    setTradeExposure(tempTradeExposure);

    const tempCostStructureAnalysis = getAllSubdimensionMatches(
      data,
      "Cost Structure Analysis"
    );
    setCostStructureAnalysis(tempCostStructureAnalysis);

    const tempSusFinInnoRisk = getAllSubdimensionMatches(
      data,
      "Sustainability, Finance, Innovation, Risks"
    );
    setSusFinInnoRisk(tempSusFinInnoRisk);

    const tempDistributionStrategy = getAllSubdimensionMatches(
      data,
      "Distribution Strategy"
    );
    setDistributionStrategy(tempDistributionStrategy);

    const tempPerformanceMetrics = getAllSubdimensionMatches(
      data,
      "Performance Metrics"
    );
    setPerformanceMetrics(tempPerformanceMetrics);

    const tempSupplyChainOverview = getAllSubdimensionMatches(
      data,
      "Supply Chain Overview"
    );
    setSupplyChainOverview(tempSupplyChainOverview);

    const tempManufacturingAndTechnologyInfrastructure =
      getAllSubdimensionMatches(data, "Global Operations Network");
    setManufacturingAndTechnologyInfrastructure(
      tempManufacturingAndTechnologyInfrastructure
    );

    const { positive, negative, sowhat, quant_snapshot } =
      getCompProfilePageInsights(data);
    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    const tempQuantSnapshots = getAllSubdimensionMatches(
      data,
      "Quantitative Snapshot"
    );
    if (tempQuantSnapshots && tempQuantSnapshots.length) {
      setPageQuantSnapshot(tempQuantSnapshots);
    } else if (quant_snapshot) {
      setPageQuantSnapshot(quant_snapshot);
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    const newChecks = {
      hasOperationsInsightTabData:
        hasData(positive) || hasData(negative) || hasData(sowhat),
      hasQuantSnapshotTabData:
        hasData(tempQuantSnapshots) || hasData(quant_snapshot),
      hasGlobalOperationsNetworkTabData: hasData(
        tempManufacturingAndTechnologyInfrastructure
      ),
      // Special check for nested suppliers array
      hasTier1SuppliersTabData:
        hasData(tempTier1Supplier) &&
        hasData(tempTier1Supplier[0]?.response?.suppliers),
      hasRawMaterialImportsData: hasData(tempRawMaterialImports),
      hasInboundLogisticsTabData: hasData(tempInboundLogistics),
      hasWarehousingChannelsTabData: hasData(tempWarehousingChannels),
      hasOutboundDistributionTabData: hasData(tempOutboundDistribution),
      hasTradeExposureTabData: hasData(tempTradeExposure),
      hasCostStructureAnalysisTabData: hasData(tempCostStructureAnalysis),
      hasSustainabilityFinanceInnovationRisksTabData:
        hasData(tempSusFinInnoRisk),
    };

    setOperationsDataCheck(newChecks);

    dataReportCheck(
      "operationsInsightTab",
      newChecks.hasOperationsInsightTabData
    );
    dataReportCheck("quantSnapshotTab", newChecks.hasQuantSnapshotTabData);
    dataReportCheck(
      "globalOperationsNetworkTab",
      newChecks.hasGlobalOperationsNetworkTabData
    );
    dataReportCheck("tier1SuppliersTab", newChecks.hasTier1SuppliersTabData);
    dataReportCheck(
      "rawMaterialImportsTab",
      newChecks.hasRawMaterialImportsData
    );
    dataReportCheck(
      "inboundLogisticsTab",
      newChecks.hasInboundLogisticsTabData
    );
    dataReportCheck(
      "warehousingChannelsTab",
      newChecks.hasWarehousingChannelsTabData
    );
    dataReportCheck(
      "outboundDistributionTab",
      newChecks.hasOutboundDistributionTabData
    );
    dataReportCheck("tradeExposureTab", newChecks.hasTradeExposureTabData);
    dataReportCheck(
      "costStructureAnalysisTab",
      newChecks.hasCostStructureAnalysisTabData
    );
    dataReportCheck(
      "sustainabilityFinanceInnovationRisksTab",
      newChecks.hasSustainabilityFinanceInnovationRisksTabData
    );
    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasOperationsInsightTabData: !!(positive || negative || sowhat),
    // }));

    // dataReportCheck(
    //   "operationsInsightTab",
    //   operationsDataCheck.hasOperationsInsightTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasQuantSnapshotTabData: tempQuantSnapshots
    //     ? !!tempQuantSnapshots
    //     : !!quant_snapshot,
    // }));

    // dataReportCheck(
    //   "quantSnapshotTab",
    //   operationsDataCheck.hasQuantSnapshotTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasGlobalOperationsNetworkTabData:
    //     !!tempManufacturingAndTechnologyInfrastructure,
    // }));
    // dataReportCheck(
    //   "globalOperationsNetworkTab",
    //   operationsDataCheck.hasGlobalOperationsNetworkTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasTier1SuppliersTabData:
    //     !!tempTier1Supplier[0]?.response?.suppliers?.length > 0,
    // }));

    // dataReportCheck(
    //   "tier1SuppliersTab",
    //   operationsDataCheck.hasTier1SuppliersTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasRawMaterialImportsData: !!tempRawMaterialImports,
    // }));
    // dataReportCheck(
    //   "rawMaterialImportsTab",
    //   operationsDataCheck.hasRawMaterialImportsData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInboundLogisticsTabData: !!tempInboundLogistics,
    // }));
    // dataReportCheck(
    //   "inboundLogisticsTab",
    //   operationsDataCheck.hasInboundLogisticsTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasWarehousingChannelsTabData: !!tempWarehousingChannels,
    // }));
    // dataReportCheck(
    //   "warehousingChannelsTab",
    //   operationsDataCheck.hasWarehousingChannelsTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasOutboundDistributionTabData: !!tempOutboundDistribution,
    // }));
    // dataReportCheck(
    //   "outboundDistributionTab",
    //   operationsDataCheck.hasOutboundDistributionTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasTradeExposureTabData: !!tempTradeExposure,
    // }));
    // dataReportCheck(
    //   "tradeExposureTab",
    //   operationsDataCheck.hasTradeExposureTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasCostStructureAnalysisTabData: !!tempCostStructureAnalysis,
    // }));
    // dataReportCheck(
    //   "costStructureAnalysisTab",
    //   operationsDataCheck.hasCostStructureAnalysisTabData
    // );

    // setOperationsDataCheck((prevState) => ({
    //   ...prevState,
    //   hasSustainabilityFinanceInnovationRisksTabData: !!tempSusFinInnoRisk,
    // }));
    // dataReportCheck(
    //   "sustainabilityFinanceInnovationRisksTab",
    //   operationsDataCheck.hasSustainabilityFinanceInnovationRisksTabData
    // );
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }, [data]);

  // useEffect(() => {
  //   console.log("QUANT SNAPSHOT: " + JSON.stringify(pageQuantSnapshot));
  // }, [pageQuantSnapshot]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps
  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  useEffect(() => {
    // trigger once after dynamic sections render
    if (dynamicSubdimension.length > 0) {
      const timer = setTimeout(() => {
        setDynamicReady((prev) => prev + 1);
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [dynamicSubdimension]);
  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="operations_wrapper">
      {/* <div className="operations_headblock">
        <div className="operations_subheadblock">
          <h5 className="operations_head">Operations & Supply Chain Profile</h5>
          <p className="operations_para">
            {competitorName ?? "Tailored Chemical Products"}{" "}
            {formatBoldTextOlder(`operates a
            vertically integrated manufacturing ecosystem with systematic
            vulnerabilities hiding operational excellence. **The shocking supply
            chain reality: $3.2M annual raw material imports from Asia create
            $2.4M tariff burden** while **350,000 sq ft across 5 facilities
            deliver same-day shipping** within 500-mile radius. **Here's the
            operational crisis: 100% manufacturing concentration in North
            Carolina creates catastrophic single-point-of-failure** during
            hurricane season yet **$8M GALA pelletizer investment proves
            modernization capability** with 12,000 lbs/hour production boost.`)}
          </p>
        </div>
        <div className="operations_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div> */}

      {
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
          subdimensionExists("Strategic Analysis") &&
          (getSubdimensionStatus("Strategic Analysis") === "generating" ? (
            <>
              Data is being generated for this element...
              <GeneratingSkeleton />
            </>
          ) : (
            operationsDataCheck.hasOperationsInsightTabData === true && (
              <div ref={operationsInsightRef}>
                <InsightBlock
                  title={""}
                  overview={""}
                  actions={[]}
                  pagePositives={pagePositives}
                  pageNegatives={pageNegatives}
                  pageSoWhat={pageSoWhat}
                />
              </div>
            )
          ))
      }

      {/* QUANT SNAPSHOT */}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Quantitative Snapshot") &&
        (getSubdimensionStatus("Quantitative Snapshot") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasQuantSnapshotTabData && (
            <div className="mb-4" ref={quantSnapshotRef}>
              <QuantSection data={pageQuantSnapshot} plantCount={plantCount} />
            </div>
          )
        ))
      )}
      {/* QUANT SNAPSHOT */}

      {/* <VendorMapOperations /> */}

      {/* <div className="global_footprint_wrapper">
        <div className="global_footprint_headblock">
          <div className="global_footprint_subheadblock">
            <h5 className="global_footprint_head">Operational Footprint</h5>
            <p className="global_footprint_para">
              Heatmap showing region-wise distribution of facilities and
              workforce.
            </p>
          </div>
        </div>
        <div className="global_footprint_headblock">
          <div className="global_footprint_subheadblock">
            <h5 className="global_footprint_head">Global Footprint</h5>
            <p className="global_footprint_para">
              Distribution of Siemens' operational presence across geographies
              and functions.
            </p>
          </div>
          <div className="global_footprint_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="global_footprint_block">
          <WorldHeatmap />
        </div>
      </div> */}

      {/* <div className="hiring_trend_wrapper">
        <div className="hiring_trend_headblock">
          <div className="hiring_trend_subheadblock">
            <h5 className="hiring_trend_head">Hiring Trend</h5>
            <p className="hiring_trend_para">
              Function vs Time view of hiring activity and talent investment.
            </p>
          </div>
          <div className="hiring_trend_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="hiring_trend_block">
          <LineChartWithShadow />
        </div>
      </div> */}

      {/* <SupplyChainOverview supplyChainOverview={supplyChainOverview} /> */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Global Operations Network") &&
        (getSubdimensionStatus("Global Operations Network") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasGlobalOperationsNetworkTabData &&
          compView !== "quantitative" && (
            <div ref={globalOperationsNetworkRef}>
              <ManufacturingAndTechnologyInfrastructure
                manufacturingAndTechnologyInfrastructure={
                  manufacturingAndTechnologyInfrastructure
                }
                plantCount={plantCount}
                setPlantCount={setPlantCount}
              />
            </div>
          )
        ))
      )}

      {/* <div ref={capexTrendsRef}>
        <CapexTrends capexTrends={capexTrends} />
      </div> */}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Tier 1 Suppliers") &&
        (getSubdimensionStatus("Tier 1 Suppliers") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasTier1SuppliersTabData && (
            <div ref={tier1SuppliersRef}>
              <Tier1Supplier
                tier1Supplier={tier1Suppliers}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Raw Material Imports") &&
        (getSubdimensionStatus("Raw Material Imports") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasRawMaterialImportsData && (
            <div ref={rawMaterialImportsRef}>
              <RawMaterialImports rawMaterialImports={rawMaterialImports} />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Inbound Logistics") &&
        (getSubdimensionStatus("Inbound Logistics") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasInboundLogisticsTabData && (
            <div ref={inboundLogisticsRef}>
              <InboundLogistics
                inboundLogistics={inboundLogistics}
                compView={compView}
              />
              {
                // clientName !== marketIqClient && (
                clientCompanyType !== APP_CONFIG.market_iq_demo && (
                  <PortsOfEntry
                    inboundLogistics={inboundLogistics}
                    compView={compView}
                  />
                )
              }
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Warehousing & Channels") &&
        (getSubdimensionStatus("Warehousing & Channels") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasWarehousingChannelsTabData && (
            <div ref={warehousingChannelsRef}>
              <WarehousingChannels
                warehousingChannels={warehousingChannels}
                compView={compView}
              />
              {
                // clientName !== marketIqClient && (
                clientCompanyType !== APP_CONFIG.market_iq_demo && (
                  <ChannelPartner
                    warehousingChannels={warehousingChannels}
                    compView={compView}
                  />
                )
              }
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Outbound Distribution") &&
        (getSubdimensionStatus("Outbound Distribution") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasOutboundDistributionTabData && (
            <div ref={outboundDistributionRef}>
              <OutboundDistributions
                outboundDistributions={outboundDistributions}
                compView={compView}
              />
              <ExportChannels
                outboundDistributions={outboundDistributions}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Trade Exposure") &&
        (getSubdimensionStatus("Trade Exposure") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasTradeExposureTabData && (
            <div ref={tradeExposureRef}>
              <TradeExposure
                tradeExposure={tradeExposure}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("Cost Structure Analysis") &&
        (getSubdimensionStatus("Cost Structure Analysis") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasCostStructureAnalysisTabData && (
            <div ref={costStructureAnalysisRef}>
              <CostStructureAnalysis
                costStructureAnalysis={costStructureAnalysis}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Sustainability, Finance, Innovation, Risks") &&
        (getSubdimensionStatus("Sustainability, Finance, Innovation, Risks") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          operationsDataCheck.hasSustainabilityFinanceInnovationRisksTabData && (
            <div ref={sustainabilityFinanceInnovationRisksRef}>
              <Sustainability
                susFinInnoRisk={susFinInnoRisk}
                compView={compView}
              />
              <Finance susFinInnoRisk={susFinInnoRisk} compView={compView} />
              <Innovation susFinInnoRisk={susFinInnoRisk} compView={compView} />
              {/* <Risks susFinInnoRisk={susFinInnoRisk} /> */}
            </div>
          )
        ))
      )}

      {/* <RawMaterialSourcing rawMaterialSourcing={rawMaterialSourcing} /> */}
      {/* <DistributionStrategy distributionStrategy={distributionStrategy} /> */}
      {/* <PerformanceMetrics performanceMetrics={performanceMetrics} /> */}

      {/* {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_operations_${index}`;

        return (
          <div key={key} ref={(el) => (dynamicRefs.current[key] = el)}>
            <h5 className="mb-4">
              {item?.response?.subdimension_name}{" "}
              <span className="dynamic-subdimension-label">
                (User generated table)
              </span>
            </h5>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })} */}

      {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_operations_${index}`;
        const title = item?.response?.subdimension_name || "Dynamic Table";

        const actions = [
          {
            type: "download",
            title: "Export CSV",
            onClick: () => exportTableToCSV(dynamicRefs.current[key], title),
          },
        ];

        return (
          <div
            key={key}
            ref={(el) => {
              if (el) {
                dynamicRefs.current[key] = el;
              }
            }}
          >
            <div className="table_head_block mb-3" style={{ display: "flex" }}>
              <div className="table_subblock_left">
                <h5 className="table_head">
                  {title}
                  <span className="dynamic-subdimension-label">
                    (User generated table)
                  </span>
                </h5>
              </div>
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "end",
                }}
              >
                <TopRightActionLinks actions={actions} />
              </div>
            </div>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })}

      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp />
        </button>
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Strategic Analysis"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default Operations;
